// extracted by mini-css-extract-plugin
module.exports = {"wrap":"DisplayOfferDeleted_wrap__8xoFp","sign":"DisplayOfferDeleted_sign__evdcI"};